import { useMemo } from "react";
import { motion } from "framer-motion";

const EASE = [0.22, 1, 0.36, 1];
const VIEWPORT = { once: true, margin: "-60px" };
const WHILE_IN_VIEW = { opacity: 1, y: 0 };

export function Reveal({ children, delay = 0, className = "", y = 24 }) {
    const initial = useMemo(() => ({ opacity: 0, y }), [y]);
    const transition = useMemo(
        () => ({ duration: 0.6, delay, ease: EASE }),
        [delay, EASE]
    );

    return (
        <motion.div
            initial={initial}
            whileInView={WHILE_IN_VIEW}
            viewport={VIEWPORT}
            transition={transition}
            className={className}
        >
            {children}
        </motion.div>
    );
}
